import React from "react";
import "../profile/profile.css";
import { Button, Typography } from "antd";
import { deleteToken } from "../../../services/AuthServices";
import DiamondIcon from "../../../assets/diamond.svg";
import { useSelector } from "react-redux";

const DashboardWrapper = ({ children, title, isReward }) => {
  const user = useSelector((state) => state.auth);

  const handleLogOut = () => {
    deleteToken();
    window.location.href = "/";
  };

  return (
    <div className="profile_wrapper">
      <div className="profile_containers">
        <div className="container_inner">
          <div className="space-between">
            <Typography className="profile_text">{title}</Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {!isReward && (
                <div className="rewardBox">
                  <img width="20px" src={DiamondIcon} alt="reward" />
                  <Typography style={{ color: "white" }}>
                    {user?.userDetails?.points?.toLocaleString()}
                  </Typography>
                </div>
              )}
              <Button type="primary" onClick={handleLogOut}>
                Log out
              </Button>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardWrapper;
